export const LOGIN = {
  SIGN_IN: {
    LABELS: {
      HEADER_TITLE: 'Sign in',
      EMAIL: 'Email',
      PASSWORD: 'Password',
      LOADING: 'Logging in...',
    },
    PLACEHOLDERS: {
      EMAIL: 'Email address',
      PASSWORD: 'Password',
    },
    ERRORS: {
      INAVLID_EMAIL_REQUIRED: 'Email is required',
      INVALID_PASSWORD_REQUIRED: 'Password is required',
      INVALID_EMAIL_PATTERN: 'Please enter a valid email address',
      INVALID_PASSWORD_PATTERN: 'Password must be at least 6 characters long',
      INVALID_CREDENTIALS: 'Incorrect email or password. Please try again',
      BUSINESS_NOT_ACTIVE: 'Business is not active.',
    },
    TOAST_MESSAGES_ERRORS: {
      LOGIN_FAIL: 'Failed to login',
    },
  },
};
